import { useImmer } from "use-immer";
import { useBatchGroupsQuery } from "./UseBatchGroupQuery";

export const useBatchGroup = ({ list }) => {
  const { updateBatchColour, listQuery } = useBatchGroupsQuery({ list });
  const [batchGroup, setBatchGroup] = useImmer({
    colour: "#C9D6C0",
    isEdit: false,
    recipeId: "",
  });

  const handleColourChange = (isEdit, colour, id) => {
    setBatchGroup((draft) => {
      draft.colour = colour;
      draft.isEdit = isEdit;
      draft.recipeId = id;
    });
  };
  const onUpdateBatchColour = (colour) => {
    const payload = {
      color: colour,
    };
    updateBatchColour.mutate({
      id: batchGroup.recipeId,
      payload,
      handleClose: handleColourChange,
    });
  };
  return {
    batchGroup,
    handleColourChange,
    onUpdateBatchColour,
    listQuery,
    updateBatchColour,
  };
};
